import { render } from "./PartnerExpert.vue?vue&type=template&id=c2b18230"
import script from "./PartnerExpert.vue?vue&type=script&lang=js"
export * from "./PartnerExpert.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__